'use strict';

module.exports = require('./lib/ReactDOM');



//////////////////
// WEBPACK FOOTER
// ./~/_react-dom@15.6.1@react-dom/index.js
// module id = 32
// module chunks = 1